import { useState } from "react";
import XLSX from "xlsx";

const EXTENSIONS = ["xlsx", "xls", "csv"];
function ImportFile() {
  const [colDefs, setColDefs] = useState([]);
  const [data, setData] = useState([]);

  const getExention = (file) => {
    const parts = file.name.split(".");
    const extension = parts[parts.length - 1];
    return EXTENSIONS.includes(extension);
  };

  const convertToJson = (headers, data) => {
    const rows = [];
    data.forEach((row) => {
      let rowData = {};
      row.forEach((element, index) => {
        rowData[headers[index]] = element;
      });
      rows.push(rowData);
    });
    return rows;
  };
  const validateData = (data) => {
    let isValid = true;
    const invalidRows = [];
    data.forEach((row, index) => {
      if (row["price"] === null || row["price"] === "") {
        isValid = false;
        invalidRows.push(index + 1); // Adding 1 to index to match row number in Excel
      }
    });

    return { isValid, invalidRows };
  };

  const importExcel = (e) => {
    const file = e.target.files[0];

    const reader = new FileReader();

    reader.onload = (event) => {
      const bstr = event.target.result;
      const workBook = XLSX.read(bstr, { type: "binary" });

      const workSheetName = workBook.SheetNames[0];
      const workSheet = workBook.Sheets[workSheetName];
      const fileData = XLSX.utils.sheet_to_json(workSheet, { header: 1 });
      const headers = fileData[0].map((head) => {
        return head.trim();
      });
      const heads = headers.map((head) => ({
        id: head.trim(),
        label: head.trim().charAt(0).toUpperCase() + head.trim().slice(1),
      }));
      setColDefs(heads);
    

      //removing header
      fileData.splice(0, 1);
      const jsonData = convertToJson(headers, fileData);
      const { isValid, invalidRows } = validateData(jsonData);

      if (!isValid) {
        alert(`The file contains null or empty values in the 'price' column at rows: ${invalidRows.join(", ")}. Please check the data and try again.`);
        return;
      }
      setData(convertToJson(headers, fileData));
      e.target.value = null;
    };

    if (file) {
      if (getExention(file)) {
        reader.readAsBinaryString(file);
      } else {
        alert("Invalid file input, Select Excel, CSV file");
      }
    } else {
      setData([]);
      setColDefs([]);
    }
  };

  return {
    data,
    colDefs,
    importExcel,
    setData,
  };
}

export default ImportFile;
